<template>
    <font-awesome-icon v-if="icon" class="fill-current" :icon="icon" />
</template>

<script setup lang="ts">
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
// eslint-disable-next-line import/no-unresolved
import {byPrefixAndName as uiIcons} from '@awesome.me/kit-4bfc2309f5/icons';
import {computedAsync} from '@vueuse/core';
import {computed} from 'vue';
import type {IconName} from '@/shared/types/icon';

// eslint-disable-next-line import/no-unresolved
const tagIconsPromise = import('@awesome.me/kit-1af7222dbb/icons');

type Props = {
    name: IconName;
    solid?: boolean;
};

const props = defineProps<Props>();

const iconPrefix = computed(() => (props.solid ? 'fas' : 'far'));

const icon = computedAsync(async () => {
    // Access reactive deps before await to ensure they're tracked
    const prefix = iconPrefix.value;
    const name = props.name;

    const {byPrefixAndName: tagIcons} = await tagIconsPromise;

    const requestedIcon =
        uiIcons[prefix]?.[name] ||
        tagIcons[prefix]?.[name] ||
        uiIcons['fak']?.[name] ||
        tagIcons['fak']?.[name];

    // Fallback to 'notdef' icon if requested icon doesn't exist
    if (!requestedIcon) {
        return uiIcons[prefix]?.['notdef'] || uiIcons['far']?.['notdef'];
    }

    return requestedIcon;
});
</script>
